import PropTypes from 'prop-types';
import React from 'react';
import { InputDiv, InputLabelDiv, DateInputField } from './InputStyles';
import moment from 'moment';

const DateInput = ({
  input,
  meta,
  label,
  first,
  placeholder,
  disabled,
  dateFormat,
  defaultToday
}) => {
  const { invalid, submitFailed } = meta;
  const showError = invalid && submitFailed ? 1 : 0;
  return (
    <InputDiv first={first}>
      <InputLabelDiv>{label}</InputLabelDiv>
      <DateInputField
        disabled={disabled}
        error={showError}
        placeholder={placeholder}
        format={dateFormat || 'DD-MM-YYYY'}
        defaultValue={input.value ? moment.utc(input.value) : defaultToday ? moment().utc(true) : ''}
        onChange={(date) =>
          date ? input.onChange(moment(date).utc(true)) : input.onChange('')
        }
      />
    </InputDiv>
  );
};

DateInput.propTypes = {
  label: PropTypes.string,
  meta: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
};

export default DateInput;
